import {Context, createContext} from 'solid-js'
import {AuthorizationProviderBehavior} from './AuthorizationProvider'

export const AuthorizationContext: Context<AuthorizationProviderBehavior> = createContext({
    authorizationHandler: () => undefined,
})
